module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/graf_img_sp-4af818e2d828cb0c412f15914ce553f6.png";